<div class="quick-message-search">
  <div class="form-header" [formGroup]="searchForm">
    <div class="search-label">{{ 'navigation_search.search_box.search-modal.label' | translate }}</div>
    <div fbc-css-grid [columns]="gridColumns" [area-template]="gridTemplate" >
        <div fbc-css-grid-column area="a" fbc-select formMapping="referenceIdField" [title]="'messages_center.quick_search.reference_id_type'"
             [options]="referenceIdOption" (valueChange)="onReferenceIdTypeChange()">
      </div>
      <div fbc-css-grid-column area="b" fbc-input [title]="'messages_center.quick_search.reference_id_value'" formMapping="referenceIdValue"
      [disabled]="!searchForm.get('referenceIdField').value" (keydown.enter)="doSearch()" #referenceIdInput>
      </div>

    </div>



    <div fbc-css-grid [columns]="gridColumns" [area-template]="gridTemplate">
      <div fbc-css-grid-column area="a" fbc-select formMapping="amountIdField" [title]="'messages_center.quick_search.amount_id_type'" [options]="amountSelectOption" (valueChange)="onAmountTypeChange($event)">
      </div>
      <div fbc-css-grid-column area="b">
        <div fbc-css-grid columns="2">
          <div fbc-css-grid-column fbc-amount [minimum]="0" formMapping="amountMinValue" [title]="'messages_center.quick_search.min_amount'" [disabled]="!searchForm.get('amountIdField').value"
               (keydown.enter)="doSearch()">
          </div>
          <div fbc-css-grid-column fbc-amount [minimum]="0" formMapping="amountMaxValue" [title]="'messages_center.quick_search.max_amount'" [disabled]="!searchForm.get('amountIdField').value"
               (keydown.enter)="doSearch()">
          </div>

        </div>
        <div fbc-css-grid-column area="c"></div>
      </div>
    </div>

    <div fbc-css-grid [columns]="gridColumns" [area-template]="gridTemplate">
      <div fbc-css-grid-column area="a" fbc-select formMapping="fieldIdType" [title]="'messages_center.quick_search.field_id_type'"
           [options]="otherFieldsOption" (valueChange)="onFieldIdTypeChange($event)">
      </div>
      <div *ngIf="searchForm.get('fieldIdType').value === 'Z_OTHERS'" fbc-css-grid-column area="b"
           fbc-drilldown
           selectList="/ui/profiles/661" dataKey="LOGICAL_FIELDS-FIELD_LOGICAL_ID" dataRoot="rows"
           [title]="'messages_center.quick_search.field_id'" formMapping="otherFieldId">
      </div>
      <div fbc-css-grid-column area="searchForm.get('fieldIdType').value === 'Z_OTHERS' ? 'c' : 'b'" fbc-input [title]="'messages_center.quick_search.field_id_value'" formMapping="fieldIdValue"
           [disabled]="!searchForm.get('fieldIdType').value" (keydown.enter)="doSearch()">
      </div>

    </div>

    <div fbc-css-grid [columns]="gridColumns" [area-template]="gridTemplate" >
      <div fbc-css-grid-column area="a" fbc-select formMapping="dateRangeType" [title]="'messages_center.quick_search.date'" [options]="dateSelectOptions" (valueChange)="onDateChange($event)">
      </div>
      <app-date-range-picker fbc-css-grid-column area="b" [startDateMapping]="'dateMinValue'"
                             [required]="searchForm.get('dateRangeType').value === 'CUSTOM'"
                             [endDateMapping]="'dateMaxValue'"></app-date-range-picker>
      <div fbc-css-grid-column area="c"></div>
    </div>

  </div>

  <div class="footer-buttons">
    <div fbc-bordered-button [text]="'navigation_search.search_box.search-modal.buttons.close'" (btnClick)="onCloseModal()"></div>
    <div fbc-bordered-button [text]="'navigation_search.search_box.search-modal.buttons.clear'" (btnClick)="clearFormValues()"></div>
    <div fbc-raised-button [text]="'navigation_search.search_box.search-modal.buttons.search'" (btnClick)="doSearch()"></div>
  </div>
</div>

